import store from '@/store/store'

export function getEntityFilters(params) {
  let roles = store.state.auth.roles.filter(
    (role) => role.confirm && role.roleId
  )

  if (roles.some((role) => role.roleId.type === 'all')) return {}

  let result = { _id: [], teamId: [] }

  roles.forEach((role) => {
    switch (role.roleId.type) {
      case 'president':
      case 'coordinator':
        if (!params._id) {
          result._id = joinParams(result._id, role.objectId)
        }
        break
      case 'trainer':
        if (!params.teamId) {
          result.teamId = joinParams(result.teamId, role.objectId)
        }
        break
    }
  })

  if (!result.teamId.length /*  || result._id.length */) delete result.teamId
  if (!result._id.length) delete result._id
  return result
}

export function getTeamFilters(params) {
  let roles = store.state.auth.roles.filter(
    (role) => role.confirm && role.roleId
  )
  if (roles.some((role) => role.roleId.type === 'all')) return {}

  let result = { entityId: [], _id: [] }
  roles.forEach((role) => {
    switch (role.roleId.type) {
      case 'president':
      case 'coordinator':
        // default: list its own club's teams
        if (!params._id && !params.entityId) {
          result.entityId = joinParams(result.entityId, role.objectId)
        }
        break
      case 'trainer':
        // default: list its own teams
        if (!params._id && !params.entityId) {
          result._id = joinParams(result._id, role.objectId)
        }
        break
    }
  })

  if (!result._id.length || (!params.entityId && result.entityId.length))
    delete result._id
  if (!result.entityId.length) delete result.entityId
  return result
}

export function getUserFilters(params) {
  let roles = store.state.auth.roles.filter(
    (role) => role.confirm && role.roleId
  )
  if (roles.some((role) => role.roleId.type === 'all')) return {}

  let result = { entity: [], team: [], typeRole: [] }

  let notParamsTypeRole =
    !params.typeRole ||
    (Array.isArray(params.typeRole) && !params.typeRole.length)

  roles.forEach((role) => {
    switch (role.roleId.type) {
      case 'president':
        if (!params.entity) {
          result.entity = joinParams(result.entity, role.objectId)
        }
        if (notParamsTypeRole) {
          result.typeRole = ['coordinator', 'trainer', 'player', 'familiar']
        }
        break
      case 'coordinator':
        if (!params.entity) {
          result.entity = joinParams(result.entity, role.objectId)
        }
        if (notParamsTypeRole) {
          result.typeRole = ['trainer', 'player', 'familiar']
        }
        break
      case 'trainer':
        if (!params.team) {
          result.team = joinParams(result.team, role.objectId)
        }
        if (notParamsTypeRole) {
          result.typeRole = ['player', 'familiar']
        }
        break
    }
  })
  if (!result.team.length || result.entity.length) delete result.team
  if (!result.typeRole.length) delete result.typeRole
  if (!result.entity.length) delete result.entity
  return result
}

export function getMatchFilters(params) {
  let roles = store.state.auth.roles.filter(
    (role) => role.confirm && role.roleId
  )
  if (roles.some((role) => role.roleId.type === 'all')) return {}

  let result = { entityId: [], teamId: [] }
  roles.forEach((role) => {
    switch (role.roleId.type) {
      case 'president':
      case 'coordinator':
        if (!params.entityId) {
          result.entityId = joinParams(result.entityId, role.objectId)
        }
        break
      case 'trainer':
        if (!params.teamId) {
          result.teamId = joinParams(result.teamId, role.objectId)
        }
        break
    }
  })

  if (!result.teamId.length || result.entityId.length) delete result.teamId
  if (!result.entityId.length) delete result.entityId
  return result
}
const joinParams = (params, item) => {
  if (!item) return params
  let result = Array.from(params)
  if (Array.isArray(item)) result = result.concat(item)
  else result.push(item)
  return result.filter((item, index, self) => self.indexOf(item) === index)
}

export function getNotificationFilters(params) {
  let roles = store.state.auth.roles.filter(
    (role) => role.confirm && role.roleId
  )
  if (roles.some((role) => role.roleId.type === 'all')) return {}

  let result = { entityId: [], teamId: [] }
  roles.forEach((role) => {
    switch (role.roleId.type) {
      case 'president':
      case 'coordinator':
        if (!params.entityId) {
          result.entityId = joinParams(result.entityId, role.objectId)
        }
        break
      case 'trainer':
        if (!params.teamId) {
          result.teamId = joinParams(result.teamId, role.objectId)
        }
        break
    }
  })

  if (!result.teamId.length || result.entityId.length) delete result.teamId
  if (!result.entityId.length) delete result.entityId
  return result
}

export function getSubscriptionFilters(params) {
  let roles = store.state.auth.roles.filter(
    (role) => role.confirm && role.roleId
  )
  if (roles.some((role) => role.roleId.type === 'all')) return {}

  let notParamsTypeRole =
    !params.typeRole ||
    (Array.isArray(params.typeRole) && !params.typeRole.length)

  let result = { entityId: [], teamId: [], typeRole: [] }
  roles.forEach((role) => {
    switch (role.roleId.type) {
      case 'president':
        if (!params.entityId) {
          result.entityId = joinParams(result.entityId, role.objectId)
        }
        if (notParamsTypeRole) {
          result.typeRole = ['coordinator', 'trainer', 'player', 'familiar']
        }
        break
      case 'coordinator':
        if (!params.entityId) {
          result.entityId = joinParams(result.entityId, role.objectId)
        }
        if (notParamsTypeRole) {
          result.typeRole = ['trainer', 'player', 'familiar']
        }
        break
      case 'trainer':
        if (!params.teamId) {
          result.teamId = joinParams(result.teamId, role.objectId)
        }
        if (notParamsTypeRole) {
          result.typeRole = ['player', 'familiar']
        }
        break
    }
  })

  if (!result.teamId.length || result.entityId.length) delete result.teamId
  if (!result.entityId.length) delete result.entityId
  if (!result.typeRole.length) delete result.typeRole
  return result
}
